export enum OrderStatus {
    NEW = 'new',
    INPROGRESS = 'inprogress',
    CANCELED = 'canceled',
    ORDERED = 'ordered',
    PROCESSED = 'processed',
}
